import { Controller } from "@hotwired/stimulus"

const SQUARE_METERS_PER_TSUBO = 3.30578

export default class extends Controller<HTMLElement> {
  static targets = ["tsubo", "sqm"]

  declare readonly tsuboTarget: HTMLInputElement
  declare readonly sqmTarget: HTMLInputElement

  fromTsubo() {
    this.convert(this.tsuboTarget, this.sqmTarget, (value) => value * SQUARE_METERS_PER_TSUBO)
  }

  fromSqm() {
    this.convert(this.sqmTarget, this.tsuboTarget, (value) => value / SQUARE_METERS_PER_TSUBO)
  }

  convert(source: HTMLInputElement, destination: HTMLInputElement, calculation: (value: number) => number) {
    if (source.value === "") {
      destination.value = ""
      return
    }

    const value = Number.parseFloat(source.value)
    if (!Number.isNaN(value)) destination.value = calculation(value).toFixed(2)
  }
}
